import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column email-login"
}
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "d-flex flex-column gap-sm" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = {
  for: "email",
  class: "form-label text-capitalize-first"
}
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = {
  key: 1,
  class: "d-flex flex-column email-login"
}
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center d-flex justify-content-center" }
const _hoisted_12 = { class: "mail-icon" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "info" }

import {reactive} from "@vue/reactivity";
import {api} from "@/service/APIClient";
import { ref} from "vue";
import {useStore} from "vuex";
import {useNotification} from "@kyvg/vue3-notification";
import {$t} from "@/i18n";
import SvgIcon from "@/components/SvgIcon.vue";
import LoaderContent from "@/components/LoaderContent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ForgotPassword',
  setup(__props) {

const state = reactive({
  email: '' as string,
  emailIsSent: false as boolean
});

const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
const store = useStore()
const notification = useNotification()

const send = async () => {
  loader.value?.load(async () => {
    try {
      await api.call.token.resetPassword(state.email)
    } catch (e) {}
    state.emailIsSent = true
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LoaderContent, {
    ref: (el) => loader.value = el
  }, {
    default: _withCtx(() => [
      (!_unref(state).emailIsSent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h1", null, _toDisplayString(_unref($t)('reset_password')), 1)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref($t)('enter_email_to_reset_password')), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString(_unref($t)('email')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).email) = $event)),
                  id: "email",
                  type: "email",
                  class: "form-control",
                  placeholder: _unref($t)('enter_email')
                }, null, 8, _hoisted_8), [
                  [_vModelText, _unref(state).email]
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (send()), ["prevent"])),
                class: "btn btn-primary w-100 btn-lg"
              }, _toDisplayString(_unref($t)('send_reset_email')), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h1", null, _toDisplayString(_unref($t)('check_your_email')), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(SvgIcon, { icon: "mail" })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_unref($t)('password_reset_email_sent')), 1)
            ])
          ]))
    ]),
    _: 1
  }, 512))
}
}

})